module.exports = __webpack_public_path__ + "img/gjsh.05668c0c.png";